export const simplifiedJobPosting = {
  header: {
    stepCounter: 'STEP %stepNumber% OF %totalSteps%',
  },
  jobPosition: {
    pay: {
      hourly: '%hourlyRate% Hourly',
      flat: '%flatRate% Flat'
    },
    editPay: 'Edit pay'
  },
  editPayModal: {
    header: 'Select the pay for this position',
    description: 'You cannot pay below minimum wage, which is %minimumWage% in %location%.',
    successMessage: 'This position\'s pay has been updated'
  },
  schedule: {
    header: 'Tell us about your schedule',
    datesLabel: 'What days do you need?',
    dateInputLabel: 'Select dates',
    totalWorkdays: 'TOTAL WORKDAYS',
    timesLabel: 'What times do you need?',
    startTimeLabel: 'Start Time',
    endTimeLabel: 'End Time',
    overnight: 'This is an overnight job',
    unpaidTime: {
      label: 'Unpaid break duration',
      hours: 'Hours',
      minutes: 'Minutes'
    },
    customizeHours: {
      text: 'If you need specific days you can ',
      button: 'customize your schedule'
    },
    customizeHoursModal: {
      title: 'Customize your schedule',
      description: 'You can edit any day individually to fit your needs',
      header: {
        workday: 'Workday',
        times: 'Start times',
      },
      saveSchedule: 'Save schedule'
    },
    shiftSummary: {
      dateRange: '%startDate% - %endDate%',
      timeRange: '%day% is %startTime% - %endTime%',
      break: '%unpaidBreakMinutes% min break'
    },
    daysVary: 'Days vary',
    viewInCalendar: 'View in calendar'
  },
  workers: {
    header: 'Select your workers',
    inputLabel: 'Enter the number of workers per workday',
    customizeWorkers: {
      text: 'If you need a different number of workers per workday, you can ',
      button: 'customize your workers',
      update: '%date% is customized for %slots% workers'
    },
    preferredTeam: {
      label: 'Preferred Team (Optional)',
      helperText: 'Select specific workers that you want this job to be sent to first so they can get a jumpstart on accepting this job',
      manage: 'Manage',
      countLabel: 'Preferred Workers'
    },
    sameWorkers: {
      label: 'Do you need the same worker for all workdays?',
      policy: {
        start: 'By selecting the same worker, the worker is entitled to ',
        policyButton: 'these policies ',
        end: ' because it spans more than 14 calendar days.'
      },
      yes: 'Yes, I need the same worker',
      no: 'No, I don’t need the same worker'
    },
    tempToHire: {
      label: 'Is this a temp-to-hire job?',
      checkbox: 'Yes, let Wonoloers know this job could lead to a permanent employment opportunity.',
    },
    customizeWorkersModal: {
      title: 'Customize your worker pool',
      description: 'You can edit any day individually to fit your needs',
      workday: 'Workday',
      hours: 'Schedule',
      scheduleValue: '%startTime% - %endTime%',
      wonoloersNeeded: 'Wonoloers needed'
    },
    lowerPool: {
      header: 'Check this box if you want to open to Lower Pool',
      description: 'Opening to Lower Pool is only recommended if you need to fill this position quickly. This boosts your fill rate, but includes workers who may be prone to cancellation.'
    }
  },
  footer: {
    continue: 'Continue'
  },
  errors: {
    dateRequired: 'Dates are required',
    startTimeRequired: 'Start time cannot be blank',
    startTimeInThePast: 'Start time must be in the future',
    endTimeRequired: 'End time cannot be blank',
    startAndEndTimeTheSame: 'Your start and end time cannot be the same',
    slotsMin: 'Slots cannot be less than 1',
    slotsMax: 'Slots cannot be more than 999',
    startDate: 'Start date cannot be empty',
    endDate: 'End date cannot be empty',
    maxNumberOfWorkdaysReached: 'You reached the 365-day limit. If you require more labor needs, you will need to create an additional job posting',
    startDateMustBeInFuture: 'Start date must be in the future',
    endDateBeforeStartDate: 'End date cannot be before start date',
    breakGreaterThanDuration: 'Break must be less than duration',
    unpaidTimeMinutes: 'Please enter a value less than 60'
  }
};
